import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { dateService } from '../../../services/date';
import { creatorWorkspaceService } from './creator-workspace-service';

import MocksButton from '../../misc/mocks-button';
import { Table, Column } from '../../ui/table';

import './content-manager.scss';

const columns = [
  {
    dataKey: 'name',
    label: 'Categories',
    width: 3,
    cellRender: ({ cellData, rowData }) => (
      <Link to={`/v2/admin/creator-workspace/content-manager/${rowData.category_id}`}>
        <div className="category-chip">{cellData}</div>
      </Link>
    ),
  },
  {
    dataKey: 'creators',
    label: 'Creators',
    width: 3,
    justifyContent: 'right',
  },
  {
    dataKey: 'active_modules',
    label: 'Active Modules',
    width: 3,
    justifyContent: 'right',
  },
  {
    dataKey: 'last_updated',
    label: 'Last Updated',
    width: 3,
    cellRender: ({ cellData }) =>
      cellData ? dateService.formatDisplayDate(cellData) : 'Invalid Date',
  },
];

const CopyLinks = () => {
  const [showMocks, setShowMocks] = useState(true);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    // getCategories();
  }, []);

  useEffect(() => {
    if (showMocks) {
      setCategories(creatorWorkspaceService.getMockCategories());
    }
  }, []);

  async function getCategories() {
    const res = await creatorWorkspaceService.getCategories();
    setCategories(res.data.data[0]);
  }

  const columnItems = columns.map((column, index) => (
    <Column
      key={index}
      dataKey={column.dataKey}
      label={column.label}
      width={column.width}
      flexWidth={true}
      sortable={column.sortable}
      justifyContent={column.justifyContent}
      cellRender={column.cellRender}
    />
  ));

  return (
    <div className="content-manager-container">
      <MocksButton setShowMocks={setShowMocks} showMocks={showMocks} />
      <div className="header">Content Manager</div>
      <div className="content">
        <Table data={categories} rowIdField="category_id">
          {columnItems}
        </Table>
      </div>
    </div>
  );
};

export default CopyLinks;
